'use client';

import { IconButton, Popover, Stack } from '@backyard-ui/core';
import { ShareOutline } from '@backyard-ui/icons';
import { isBrowser } from '@backyard-ui/utils';

import socialMediaList from './constants';
import { styles } from './ShareButton.styles';

function ShareButton() {
  // Essa verificação pode causar erros de hidratação no navegador.
  // Neste caso não ocorre pois o conteúdo do popover só é renderizado no navegador.
  const pageUrl = isBrowser ? window.location.href : '';

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <IconButton
          icon={<ShareOutline />}
          variant="ghost"
          radius="md"
          size="sm"
        />
      </Popover.Trigger>
      <Popover.Content side="left" align="start">
        <Popover.Header>Compartilhar</Popover.Header>
        <Popover.Body>
          <Stack spacing="2" justify="center">
            {socialMediaList.map((socialMedia) => {
              const Icon = socialMedia.icon;

              return (
                <a
                  key={socialMedia.name}
                  href={`${socialMedia.url}${pageUrl}`}
                  title={socialMedia.label}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <div className={styles({ social: socialMedia.name })}>
                    <Icon />
                  </div>
                </a>
              );
            })}
          </Stack>
        </Popover.Body>
      </Popover.Content>
    </Popover.Root>
  );
}

export default ShareButton;
